export default __webpack_public_path__ + "static/media/logo.3bf9c474.svg";